import httpBuildQuery from 'http-build-query';


const chunkArray = (myArray, chunkSize) => {
  const results = [];
  const array = myArray.slice();

  while (array.length) {
    results.push(array.splice(0, chunkSize));
  }

  return results;
};

const parseErrorMessage = (error) => {
  console.log(error);

  if (error.response && error.response.data && error.response.data.error) {
    return error.response.data.error;
  }

  if (!error.data) {
    return error.message;
  }

  return error.data;
};

const serialize = (params) => {
  if (typeof params !== 'object' || Object.keys(params).length === 0) {
    return '';
  }

  const queryString = Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');
  return `?${queryString}`;
};

const convertToSearchCriteria = ({
  searchConditions = {},
  filterConditions,
  pageSize = 100,
  currentPage = 1,
  sortField = 'created_at',
  sortDirection = 'desc'
}) => {
  //return separate filters arrays to use AND condition
  //to use OR condition add filter object in one filters array
  const filters = Object.values(filterConditions).map((filter) => {
    const searchField = searchConditions?.field;

    if (searchField === filter.field) {
      return {filters: [filter, searchConditions]};
    }

    return {filters: [filter]};
  });

  const isSearchFieldInFilters = filters.filter((filter) => {
    return filter?.filters.filter(
      (filter) => filter.field === searchConditions?.field
    ).length > 0;
  });

  const query = {
    searchCriteria: {
      sortOrders: [
        {
          field: sortField,
          direction: sortDirection
        }
      ],
      pageSize,
      currentPage,
      filterGroups: [
        {
          //for search field on UI:
          //  use empty array for OR condition if on search
          //  and on filter selected same fields
          filters: isSearchFieldInFilters.length ? [] : [searchConditions]
        },
        ...filters
      ]
    }
  };

  return httpBuildQuery(query);
};

const getErrorMessageFromBlob = async (blob) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      let errorMessage;

      if (typeof reader.result === 'string') {
        errorMessage = JSON.parse(reader.result).error;
      } else if (reader.result instanceof ArrayBuffer) {
        const decoder = new TextDecoder();
        errorMessage = JSON.parse(decoder.decode(reader.result)).error;
      }

      resolve(errorMessage);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsText(blob);
  });
};

const toSnakeCase = (str) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export { chunkArray, parseErrorMessage, serialize, convertToSearchCriteria, getErrorMessageFromBlob, toSnakeCase };
